import styles from '../styles/navigation.module.scss';
import { objectKeys } from '@utils/functions';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { ForumRoutes } from '../constants/routes';

function Navigation() {
  const { url } = useRouteMatch();

  return (
    <nav className={styles.menuItems}>
      {objectKeys(ForumRoutes).map((key) => (
        <NavLink key={key} activeClassName={styles.active} to={url + '/' + ForumRoutes[key]}>
          {ForumRoutes[key].replace('_', ' ')}
        </NavLink>
      ))}
    </nav>
  );
}

export default Navigation;
